import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import * as Component from '../../../../shared/components';
import Content from '../components/tab/Content';
import Poster from '../components/tab/Poster';
import SeasonDetail from '../components/tab/SeasonDetail';

const SeasonEdit: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams<{ id: string }>();
  const [] = useState(true);

  const components = [
    {
      key: 'detail',
      title: 'Detail',
      component: <SeasonDetail />,
    },
    {
      key: 'poster',
      title: 'Poster',
      component: <Poster seasonId={Number(id)} />,
    },
    {
      key: 'content',
      title: 'Content',
      component: (
        <Content
          seasonId={Number(id)}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      ),
    },
  ];

  return (
    <Component.BasePageComponent>
      <Component.TapComponent
        components={components}
        setSearchParams={setSearchParams}
        searchParams={searchParams}
      />
    </Component.BasePageComponent>
  );
};

export default observer(SeasonEdit);
